import { H3 } from 'components/Common';
import styled from 'styled-components';

export const Container = styled.div`
  background: ${({ theme }) => theme.color.Gray10};
  height: 682px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  @media (max-width: 1279px) {
    height: auto;
    min-height: 100dvh;
    padding: 0 20px;
    box-sizing: border-box;
    background: ${({ theme }) => theme.color.White};
  }
`;

export const Modal = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 521px;
  height: 432px;
  box-sizing: border-box;
  box-shadow: 10px 10px 30px 14px rgba(0, 0, 0, 0.05);
  border-radius: 32px;

  @media (max-width: 1279px) {
    height: auto;
    padding: 0 20px;
    box-shadow: none;
    border-radius: 0;
  }
`;

export const CompleteTitle = styled(H3)`
  text-align: center;

  @media (max-width: 1279px) {
    font-size: 24px;
    line-height: 1.4;
  }
`;

export const LandingButton = styled.button`
  width: 100%;
  max-width: 331px;
  height: 45px;
  background: rgba(255, 45, 46, 1);
  border-radius: 8px;
  color: rgba(255, 255, 255, 1);
  border: none;
  cursor: pointer;
  text-align: center;
  align-content: center;

  @media (max-width: 1279px) {
    max-width: none;
    height: 54px;
  }
`;
